import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const splitDocuments = async ({
  companyId,
  extractedDocumentId,
  documents,
  token,
}: APIRequest<{
  companyId: number;
  extractedDocumentId: number;
  documents: Array<any>;
}>): APIResponsePromise =>
  await _callBackend(
    '/extracted_documents/split_documents',
    'POST',
    {
      company_id: companyId,
      extracted_document_id: extractedDocumentId,
      documents,
    },
    token,
  );

export const updateDescription = async ({
  id,
  companyId,
  description,
  token,
}: APIRequest<{
  id: number;
  companyId: number;
  description: string;
}>): APIResponsePromise =>
  await _callBackend(
    `/extracted_documents/${id}/update_description`,
    'POST',
    {
      company_id: companyId,
      description,
    },
    token,
  );

export const markAsOthers = async ({
  extractedDocumentId,
  companyId,
  markedAsOthers,
  token,
}: APIRequest<{
  extractedDocumentId: number;
  companyId: number;
  markedAsOthers: boolean;
}>): APIResponsePromise =>
  await _callBackend(
    `/extracted_documents/${extractedDocumentId}/update_marked_as_others`,
    'POST',
    {
      company_id: companyId,
      marked_as_others: markedAsOthers,
    },
    token,
  );

export const autoSplitDocument = async ({
  companyId,
  extractedDocumentId,
  token,
}: APIRequest<{
  companyId: number;
  extractedDocumentId: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/integrations/auto_split_documents',
    'POST',
    {
      company_id: companyId,
      extracted_document_id: extractedDocumentId,
    },
    token,
  );

export const restoreDeletedDocument = async ({
  companyId,
  extractedDocumentId,
  token,
}: APIRequest<{
  companyId: number;
  extractedDocumentId: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/integrations/restore_deleted_document',
    'POST',
    {
      company_id: companyId,
      extracted_document_id: extractedDocumentId,
    },
    token,
  );
